import merge from 'lodash/merge'

export const mergeObjects = (destination: any, source: any) => {
  return merge(destination, source)
}

export default mergeObjects
